import { render, staticRenderFns } from "./PreviewSalaryModal.vue?vue&type=template&id=31282241&scoped=true&"
import script from "./PreviewSalaryModal.vue?vue&type=script&lang=js&"
export * from "./PreviewSalaryModal.vue?vue&type=script&lang=js&"
import style0 from "./PreviewSalaryModal.vue?vue&type=style&index=0&id=31282241&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31282241",
  null
  
)

component.options.__file = "PreviewSalaryModal.vue"
export default component.exports